<template>
  <div class="fab-nav">
    <ul>
      <li class="logo" @click="goHome()">
        <span>DHAL</span>
        <span>Studio</span>
      </li>
      <li>
        <router-link to="/portfolio">Portfolio</router-link>
      </li>
      <li>
        <router-link to="/about">About</router-link>
      </li>

      <template v-if="loggedIn">
        <li>
          <router-link to="/login">Admin</router-link>
        </li>
        <li class="push-right">
          <a href @click.prevent="onSignOut">Logout</a>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  computed: {
    loggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  },
  methods: {
    onSignOut() {
      this.$store.dispatch("logOut");
    },
    goHome() {
      this.$router.push({ path: "/" });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/sass/_vars.scss";

.push-right {
  a {
    color: gray !important;
  }
  margin-left: auto;
}

.fab-nav {
  background: black;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  a {
    color: #9b9b9b;
    font-weight: 300;
    text-decoration: none;
    padding: 0;
    height: 8rem;
    display: flex;
    align-items: center;
    border-bottom: 1px solid transparent;

    &.router-link-exact-active {
      color: white;
      border-bottom: 1px solid #aaa;
    }
  }
  ul {
    width: 100%;
    margin: 0;
    display: flex;
    padding: 0;
    li {
      margin: 0;
      list-style-type: none;
      display: flex;
      align-items: center;
      font-size: 1.5rem;
      &:not(:last-child) {
        margin-right: 2rem;
      }

      &.logo {
        border-bottom: 1px solid transparent;
        $color: #d1cc9f;
        cursor: pointer;
        color: $color;
        font-weight: 300;
        display: flex;
        align-items: center;
        span:first-child {
          letter-spacing: 2px;
          font-weight: 600;
        }
        span:last-child {
          letter-spacing: 0.2px;
          margin: 0;
          margin-left: 0px;
        }
      }
    }

    li.icon-link {
      flex: 1;
      display: flex;
      align-items: center;
      &:last-child {
        flex: 0;
        a {
          color: gray;
        }
      }
      a {
        display: flex;
        align-items: center;
        i.material-icons {
          margin-right: 5px;
        }
      }
    }
  }
}

@media only screen and (max-width: 500px) {
  .fab-nav {
    a {
      height: 4.5rem;
    }
    ul {
      li.logo {
        flex: 1;
      }
    }
  }
}
</style>

